﻿import { Link } from "react-router-dom";
import type { EmergencyEventItem } from "@/types.ts";
import { formatDateTime } from "@/lib/format";
interface EventStreamProps {
    events: EmergencyEventItem[];
}
const getEventLabel = (event: EmergencyEventItem) => {
    return event.eventTypeShortName ?? event.eventTypeName ?? event.eventType;
};
const getStatusLabel = (event: EmergencyEventItem) => {
    return event.eventStatusShortName ?? event.eventStatusName ?? event.eventStatus;
};
const getPriority = (event: EmergencyEventItem): "high" | "medium" | "low" => {
    if (event.riskLevel === "HIGH" || event.eventStatus === "OPEN")
        return "high";
    if (event.riskLevel === "MEDIUM" || event.eventStatus === "IN_PROGRESS")
        return "medium";
    return "low";
};
const typeConfig = {
    high: { dot: "bg-red-500", text: "text-red-700", row: "bg-red-50/40" },
    medium: { dot: "bg-orange-500", text: "text-orange-700", row: "bg-orange-50/30" },
    low: { dot: "bg-slate-400", text: "text-slate-700", row: "" },
};
const EventStream = ({ events }: EventStreamProps) => {
    return (<div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
      <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <i className="ri-pulse-line text-blue-500 text-sm"/>
          <h3 className="text-sm font-semibold text-slate-800">이벤트 스트림</h3>
          <span className="flex items-center gap-1 text-xs text-emerald-600">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"/>
            최근 이벤트
          </span>
        </div>
        <Link to="/admin/emergency" className="text-xs text-blue-600 hover:text-blue-700 font-medium">
          전체 로그
        </Link>
      </div>

      <div className="divide-y divide-slate-100 max-h-80 overflow-y-auto">
        {events.length === 0 ? (<div className="px-4 py-8 text-center text-sm text-slate-500">최근 긴급 이벤트가 없습니다.</div>) : (events.map((event) => {
            const priority = getPriority(event);
            const cfg = typeConfig[priority];
            return (<Link key={event.eventId} to="/admin/emergency" className={`block px-4 py-2.5 hover:bg-slate-50 transition-colors ${cfg.row}`}>
                <div className="flex items-start gap-2.5">
                  <div className="flex flex-col items-center pt-1.5 shrink-0">
                    <span className={`w-2 h-2 rounded-full ${cfg.dot}`}/>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2">
                      <p className={`text-xs font-semibold ${cfg.text} leading-snug`}>
                        [{getStatusLabel(event)}] {event.elderlyName} - {getEventLabel(event)}
                      </p>
                      <span className="text-xs text-slate-400 shrink-0">{formatDateTime(event.occurredAt, 11, 16)}</span>
                    </div>
                    <p className="text-xs text-slate-500 mt-0.5">
                      {event.description ?? event.eventTypeDescription ?? "상세 설명이 등록되지 않았습니다."}
                    </p>
                  </div>
                </div>
              </Link>);
        }))}
      </div>
    </div>);
};
export default EventStream;
